import React from 'react';
import type { IProps as ITabsBlockProps, ITabItem } from './TabsBlock.interface';
import { TabsBlock } from './TabsBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';


// Define input props structure, potentially from a CMS or external data source
// It mirrors ITabsBlockProps but doesn't extend IBlockWrapperProps directly at this level.
// It includes [key: string]: any to allow passthrough of other props which might include BlockWrapper settings.
export interface ITabsBlockInputProps {
    tabs: {
        id: string;
        title: string;
        items: any[];
    }[]
    // Allow other props to be passed through, which might include BlockWrapper props
    [key: string]: any;
}

const mapInputToProps = (input: ITabsBlockInputProps): ITabsBlockProps => {
    const { tabs, ...rest } = input;

    return {
        tabs: tabs && tabs.length > 0 ? tabs.map((tab: any) => ({
            value: tab.id,
            label: tab.title,
            items: tab.items,
        })) : [],
        ...rest
    };
};

const TabsBlockTranslation: React.FC<ITabsBlockInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={TabsBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default TabsBlockTranslation;
